import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/media-monitoring")({
  component: MediaMonitoringLayout,
});

function MediaMonitoringLayout() {
  return <Outlet />;
}
